/* 컬렉션 배너 — 테마 assets 폴백 이미지가 없을 때 제목만 남긴다.
 *
 * ⚠️ Liquid 로는 `assets/` 에 파일이 있는지 확인할 수 없다. 그래서 컬렉션 핸들로 파일명을
 *    조립해 일단 넣고, 404 면 여기서 걷어낸다 — 없으면 **깨진 이미지 아이콘**이 남는다.
 * ⚠️ metafield 로 이미지를 넣은 컬렉션에는 이 스크립트가 로드되지 않는다(섹션이 조건부로
 *    출력한다) — 그 경로는 이미지 존재가 보장된다.
 */
(() => {
  "use strict";

  const fail = (img) => {
    const wrap = img.closest(".ncb");
    if (!wrap) return;
    /* 같은 배너의 PC·모바일 두 장 중 하나만 없을 수도 있다 — 남은 장이 있으면 유지한다. */
    img.remove();
    if (!wrap.querySelector(".ncb-img")) wrap.classList.add("ncb--title-only");
  };

  const wire = (img) => {
    if (img.dataset.ncbWired) return;
    img.dataset.ncbWired = "1";
    /* 이미 로드가 끝나 실패한 경우(캐시)도 잡는다 — `error` 이벤트는 다시 오지 않는다. */
    if (img.complete && img.naturalWidth === 0) {
      fail(img);
      return;
    }
    img.addEventListener("error", () => fail(img), { once: true });
  };

  const run = () => document.querySelectorAll("img[data-ncb-asset]").forEach(wire);

  run();
  document.addEventListener("shopify:section:load", run);
})();
